import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/90 to-secondary py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center space-x-2 bg-primary-foreground/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <Icon name="Rocket" size={20} className="text-primary-foreground" />
              <span className="text-sm font-medium text-primary-foreground">
                Your Success Journey Starts Here
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground leading-tight">
              Implementation Hub
            </h1>
            
            <p className="text-lg md:text-xl text-primary-foreground/90 leading-relaxed">
              Comprehensive resources, expert guidance, and community support to ensure your camlytix AI deployment succeeds from day one.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Play"
                iconPosition="left"
                className="bg-accent hover:bg-accent/90 text-accent-foreground"
                onClick={() => document.getElementById('quick-start')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Start Implementation
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="BookOpen"
                iconPosition="left"
                className="bg-primary-foreground/10 hover:bg-primary-foreground/20 text-primary-foreground border-primary-foreground/30"
                onClick={() => document.getElementById('knowledge-base')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Browse Resources
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-2xl p-8 border border-primary-foreground/20">
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-primary-foreground/10 rounded-xl p-6 text-center">
                  <Icon name="FileText" size={32} className="text-accent mx-auto mb-3" />
                  <div className="text-3xl font-bold text-primary-foreground mb-1">500+</div>
                  <div className="text-sm text-primary-foreground/80">Documentation Pages</div>
                </div>
                <div className="bg-primary-foreground/10 rounded-xl p-6 text-center">
                  <Icon name="Video" size={32} className="text-accent mx-auto mb-3" />
                  <div className="text-3xl font-bold text-primary-foreground mb-1">150+</div>
                  <div className="text-sm text-primary-foreground/80">Video Tutorials</div>
                </div>
                <div className="bg-primary-foreground/10 rounded-xl p-6 text-center">
                  <Icon name="Users" size={32} className="text-accent mx-auto mb-3" />
                  <div className="text-3xl font-bold text-primary-foreground mb-1">10K+</div>
                  <div className="text-sm text-primary-foreground/80">Community Members</div>
                </div>
                <div className="bg-primary-foreground/10 rounded-xl p-6 text-center">
                  <Icon name="Award" size={32} className="text-accent mx-auto mb-3" />
                  <div className="text-3xl font-bold text-primary-foreground mb-1">98%</div>
                  <div className="text-sm text-primary-foreground/80">Success Rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;